import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createDog, type Dog } from '@/api/entities/dogs';
import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';
import { useCognitoAuth } from '@/hooks/useCognitoAuth';
import { GraphQLRequestError } from '@/api/graphql';

type QueryFnType = typeof createDog;

type UseCreateDogOptions = {
  config?: MutationConfig<QueryFnType>;
};

export const useCreateDog = ({ config }: UseCreateDogOptions = {}) => {
  const queryClient = useQueryClient();
  const { getAccessToken } = useCognitoAuth();

  return useMutation<ExtractFnReturnType<QueryFnType>, GraphQLRequestError, Partial<Dog>>({
    ...config,
    mutationFn: async (input: Partial<Dog>) => {
      return createDog(input, getAccessToken);
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({ queryKey: ['dogs'] });
      config?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
